/* The Barn Dallas — 2026 v6 */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var s = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  var locks = 0;
  function lock() { locks++; document.body.classList.add('is-locked'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) document.body.classList.remove('is-locked'); }

  var scrim = $('[data-scrim]');
  function showScrim() { if (scrim) scrim.classList.add('is-open'); }
  function hideScrim() { if (scrim) scrim.classList.remove('is-open'); }

  function closeAll() {
    $$('.is-open[data-panel]').forEach(function (p) { p.classList.remove('is-open'); unlock(); });
    $$('.mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    $$('[data-mega-trigger][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    hideScrim();
  }
  function openPanel(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open'); lock(); showScrim();
  }
  function closePanel(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); unlock(); hideScrim();
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel($('[data-panel="' + o.getAttribute('data-open') + '"]')); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closePanel(c.closest('[data-panel]')); return; }
    if (e.target.closest('[data-scrim]')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  var megaTimer;
  $$('[data-mega-trigger]').forEach(function (trigger) {
    var panel = $('[data-mega="' + trigger.getAttribute('data-mega-trigger') + '"]');
    if (!panel) return;
    var open = function () {
      clearTimeout(megaTimer);
      $$('.mega.is-open').forEach(function (m) { if (m !== panel) m.classList.remove('is-open'); });
      $$('[data-mega-trigger]').forEach(function (t) { if (t !== trigger) t.setAttribute('aria-expanded', 'false'); });
      panel.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      megaTimer = setTimeout(function () {
        panel.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false');
      }, 160);
    };
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('mouseleave', close);
    panel.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    panel.addEventListener('mouseleave', close);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) { close(); } else { open(); }
    });
  });

  $$('[data-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.nextElementSibling;
      if (!sub) return;
      var on = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      var pm = btn.querySelector('.pm'); if (pm) pm.textContent = on ? '−' : '+';
    });
  });

  $$('[data-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var on = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  });

  (function () {
    var items = $$('.util__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4200);
  })();

  (function () {
    var els = $$('.rise');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  })();

  (function () {
    var ov = $('[data-panel="search"]');
    if (!ov) return;
    var input = $('[data-search-input]', ov);
    var results = $('[data-search-results]', ov);
    var t;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open="search"]')) setTimeout(function () { if (input) input.focus(); }, 260);
    });
    if (!input || !results) return;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive]');
            results.innerHTML = inner ? inner.innerHTML : '';
          }).catch(function () {});
      }, 220);
    });
  })();

  var drawer = function () { return $('[data-panel="cart"]'); };

  function refreshCart(open) {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-panel="cart"]');
        var cur = drawer();
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var n = fresh.getAttribute('data-count') || '0';
          cur.setAttribute('data-count', n);
          $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
        }
        if (open) openPanel(cur);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = res.ok ? label : (res.d.description || 'Unavailable'); }
        if (res.ok) return refreshCart(true);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-change]');
    if (!q) return;
    e.preventDefault();
    var line = q.getAttribute('data-line');
    var qty = q.getAttribute('data-line-change');
    q.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    }).then(function () { return refreshCart(false); })
      .then(function () { if (window.location.pathname.indexOf('/cart') === 0) window.location.reload(); });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-quick-add');
    var label = b.textContent;
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { b.disabled = false; b.textContent = label; return refreshCart(true); })
      .catch(function () { b.disabled = false; b.textContent = label; });
  });

  $$('[data-product-form]').forEach(function (root) {
    var holder = $('[data-variants]', root);
    if (!holder) return;
    var data = JSON.parse(holder.textContent);
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var submit = $('[data-submit]', root);
    var gallery = $('[data-gallery]');
    var selected = {};

    $$('[data-opt]', root).forEach(function (b) {
      if (b.classList.contains('is-on')) selected[b.getAttribute('data-opt')] = b.getAttribute('data-val');
    });

    function match() {
      return data.filter(function (v) {
        return v.options.every(function (o, i) {
          var name = String(i + 1);
          return selected[name] === undefined || selected[name] === o;
        });
      })[0];
    }

    function paint() {
      $$('[data-opt]', root).forEach(function (b) {
        var pos = b.getAttribute('data-opt');
        var val = b.getAttribute('data-val');
        b.classList.toggle('is-on', selected[pos] === val);
        var test = {};
        Object.keys(selected).forEach(function (k) { test[k] = selected[k]; });
        test[pos] = val;
        var any = data.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            var n = String(i + 1);
            return test[n] === undefined || test[n] === o;
          });
        });
        b.classList.toggle('is-out', !any);
      });

      var v = match();
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? money(v.price) + ' <s>' + money(v.compare_at_price) + '</s>'
          : money(v.price);
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? (submit.getAttribute('data-label') || 'Add to bag') : 'Sold out';
      }
      $$('[data-opt-value]', root).forEach(function (el) {
        var p = el.getAttribute('data-opt-value');
        if (selected[p]) el.textContent = selected[p];
      });
      if (v.featured_media_id && gallery) {
        var fig = gallery.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (fig && window.innerWidth > 989) fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (err) {}
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt]');
      if (!b) return;
      e.preventDefault();
      selected[b.getAttribute('data-opt')] = b.getAttribute('data-val');
      paint();
    });

    paint();
  });

  (function () {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var gridEl = $('[data-product-grid]');
    $$('[data-cols]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-cols');
        if (!gridEl) return;
        gridEl.className = gridEl.className.replace(/grid--\d/, 'grid--' + c);
        $$('[data-cols]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        try { localStorage.setItem('tbd-cols', c); } catch (err) {}
      });
    });
    try {
      var saved = localStorage.getItem('tbd-cols');
      if (saved && gridEl && window.innerWidth > 749) {
        var t = $('[data-cols="' + saved + '"]'); if (t) t.click();
      }
    } catch (err) {}
  })();

  $$('[data-ticker]').forEach(function (track) {
    var unit = track.firstElementChild;
    if (!unit) return;
    track.appendChild(unit.cloneNode(true));
    var speed = parseFloat(track.getAttribute('data-speed') || '30');
    track.style.animationDuration = speed + 's';
  });
})();
